module.exports = __webpack_public_path__ + "img/ertiga-xl7.d6e22f02.png";